export const SHAPE_CORNERS = [
  { label: "Top left", x: "topLeftOffsetX", y: "topLeftOffsetY", radius: "borderTopLeftRadius" },
  { label: "Top right", x: "topRightOffsetX", y: "topRightOffsetY", radius: "borderTopRightRadius" },
  { label: "Bottom right", x: "bottomRightOffsetX", y: "bottomRightOffsetY", radius: "borderBottomRightRadius" },
  { label: "Bottom left", x: "bottomLeftOffsetX", y: "bottomLeftOffsetY", radius: "borderBottomLeftRadius" },
];

const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;

export const getShapeVertices = (settings, width = 100, height = 100) => [
  [number(settings.topLeftOffsetX) * width / 100, number(settings.topLeftOffsetY) * height / 100],
  [width + number(settings.topRightOffsetX) * width / 100, number(settings.topRightOffsetY) * height / 100],
  [width + number(settings.bottomRightOffsetX) * width / 100, height + number(settings.bottomRightOffsetY) * height / 100],
  [number(settings.bottomLeftOffsetX) * width / 100, height + number(settings.bottomLeftOffsetY) * height / 100],
];

export const getRoundedPolygonPath = (vertices, radii) => {
  const points = vertices.map((point, index) => {
    const previous = vertices[(index + vertices.length - 1) % vertices.length];
    const next = vertices[(index + 1) % vertices.length];
    const requested = Math.max(0, number(radii[index]));
    const previousLength = Math.hypot(point[0] - previous[0], point[1] - previous[1]);
    const nextLength = Math.hypot(point[0] - next[0], point[1] - next[1]);
    const radius = Math.min(requested, previousLength / 2, nextLength / 2);
    const toward = (other, distance, length) => [
      point[0] + ((other[0] - point[0]) * distance / (length || 1)),
      point[1] + ((other[1] - point[1]) * distance / (length || 1)),
    ];
    return { point, start: toward(previous, radius, previousLength), end: toward(next, radius, nextLength) };
  });

  return `${points.map(({ point, start, end }, index) =>
    `${index === 0 ? "M" : "L"} ${start[0]} ${start[1]} Q ${point[0]} ${point[1]} ${end[0]} ${end[1]}`
  ).join(" ")} Z`;
};
